<template>
   <v-container pt-2>
      <v-layout column>
         <a-select-field 
               clearable label="Produto" 
               obj="productType" sm4 v-model="filterData.productTypeId"
               ref="productTypeIdField" required
         ></a-select-field>

         <a-select-field 
               clearable label="Por Campanha" 
               :filter-by="{affiliateId: this.$store.state.company.user.id}"
               obj="campaign" objMethod="getMyBrandLinks" sm4
               v-model="filterData.campaignId" required
               updateWithFilters
               ref="campaignIdField"
         ></a-select-field>
      </v-layout>
   </v-container>
</template>

<script>

   export default {

      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data () {
         return {
            filterData: {
               productTypeId: null,
               affiliateId: null,
               campaignId: null
            },
         };
      },

      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute (val) {
            val && this.applyFilter();
         }
      },

      methods: {
         applyFilter () {
            let filters = [];

            let productTypeName;
            if(this.filterData.productTypeId  && this.$refs.productTypeIdField && this.$refs.productTypeIdField.items.length){
               let auxText = this.$refs.productTypeIdField.items.find(el => el.id == this.filterData.productTypeId);
               productTypeName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'productTypeId', value: this.filterData.productTypeId, label: productTypeName});

            let campaignName;
            if(this.filterData.campaignId  && this.$refs.campaignIdField && this.$refs.campaignIdField.items.length){
               let auxText = this.$refs.campaignIdField.items.find(el => el.id == this.filterData.campaignId);
               campaignName = auxText && auxText.name ? auxText.name : null
            }
            filters.push({field: 'campaignId', value: this.filterData.campaignId, label: campaignName});

            this.$store.dispatch('updateAllPageFilters', filters);

            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters () {
            this.$util.updateObj(this.filterData, this.$store.getters.activePageFilters);
         }
      },
   };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/CampaignLeadsFilter.vue